import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {DynamicFormConfig} from '../../dynamic-form/dynamic-form.config';
import {DynamicFormAutofillService} from '../dynamic-form-autofill.service';

@Component({
    selector: 'mydocma-autofill',
    templateUrl: './autofill.component.html',
    styleUrls: ['./autofill.component.scss'],
    host: {'class': 'mydocma-autofill-select'}
})
export class AutofillComponent implements OnInit {
    @ViewChild('select', {static: true}) select;
    @Input() formConfig: DynamicFormConfig;

    constructor(private readonly dynamicFormAutoFillService: DynamicFormAutofillService) {
    }

    private openAutofillSelect(formName) {
        if (this.select['id'] === formName) {
            this.select.open();
        }
    }

    public ngOnInit(): void {
        this.dynamicFormAutoFillService.autoFillSelect.subscribe((formName) => {
            this.openAutofillSelect(formName);
        });
    }

    public applyOptionConfig(config) {
        this.dynamicFormAutoFillService.setFormConfiguration(this.formConfig.name, config);
    }
}
